<div class="mapping-result-page" *ngIf="result">
  <div class="page-header">
    <h1 class="page-title">Field Mapping</h1>
    <p class="page-subtitle">
      {{ mappedCount }} of {{ totalCount }} fields mapped
    </p>
  </div>

  <!-- Ignored fields info banner -->
  <div class="info-banner info-banner--warning" *ngIf="ignoredRows.length > 0">
    <mat-icon class="info-banner__icon">visibility_off</mat-icon>
    <div class="info-banner__content">
      <span class="info-banner__title">{{ ignoredRows.length }} ignored field{{ ignoredRows.length > 1 ? 's' : '' }}</span>
      <span class="info-banner__text">These fields will be excluded from import</span>
    </div>
  </div>

  <!-- Mapping table -->
  <div class="mapping-table-container">
    <table class="mapping-table">
      <thead>
        <tr>
          <th class="col-status">Status</th>
          <th class="col-data-source">Data Source Field</th>
          <th class="col-rubii-field">Rubii Field</th>
          <th class="col-ignore">IGNORE</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of rows"
            class="mapping-row"
            [class.mapping-row--ignored]="row.isIgnored"
            [class.mapping-row--unmapped]="row.status === 'unmapped' && !row.isIgnored">
          <td class="cell-status">
            <mat-icon class="status-icon" [ngClass]="getStatusClass(row.status)">
              {{ getStatusIcon(row.status) }}
            </mat-icon>
          </td>
          <td class="cell-data-source">
            <div class="field-label">{{ row.sourceField }}</div>
            <div class="field-category">{{ row.category }}</div>
          </td>
          <td class="cell-rubii-field">
            <!-- Mapped -->
            <div *ngIf="row.status === 'mapped' && !row.isIgnored"
                 class="rubii-field-pill pill--mapped">
              {{ row.rubiiFieldLabel }}
            </div>
            <!-- Suggested / auto-generated -->
            <div *ngIf="(row.status === 'auto-generated' || row.status === 'derived') && !row.isIgnored"
                 class="rubii-field-pill pill--suggested">
              {{ row.rubiiFieldLabel }}
            </div>
            <!-- Unmapped -->
            <div *ngIf="row.status === 'unmapped' && !row.isIgnored"
                 class="rubii-field-pill pill--unsupported">
              Not yet supported
            </div>
            <!-- Ignored -->
            <div *ngIf="row.isIgnored" class="rubii-field-pill pill--unsupported">
              Ignored
            </div>
            <div class="rubii-field-reason" *ngIf="row.reason && !row.isIgnored">{{ row.reason }}</div>
          </td>
          <td class="cell-ignore">
            <button class="ignore-toggle"
                    [class.ignore-toggle--active]="row.isIgnored"
                    (click)="toggleIgnore(rows.indexOf(row))"
                    [disabled]="row.status === 'unmapped'"
                    [attr.aria-label]="row.isIgnored ? 'Unignore field' : 'Ignore field'">
              <mat-icon>{{ row.isIgnored ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Summary counts -->
  <div class="mapping-summary">
    <div class="summary-item summary-item--mapped">
      <mat-icon>check_circle</mat-icon>
      <span>{{ mappedCount }} mapped</span>
    </div>
    <div class="summary-item summary-item--ignored" *ngIf="ignoredRows.length > 0">
      <mat-icon>visibility_off</mat-icon>
      <span>{{ ignoredRows.length }} ignored</span>
    </div>
  </div>

  <!-- Action buttons -->
  <div class="action-section">
    <button class="btn btn-outline" (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>
      Back
    </button>
    <button class="btn btn-primary" (click)="save()">
      <mat-icon>check</mat-icon>
      Save Mapping
    </button>
  </div>
</div>
